import React from 'react';
import { phoneNumber, currentLocation } from '../../helpers/locationHelper';
import balogo from './ba-logo.svg';

const MetaBar = (props) => {
  return(

    <div className="row">
      <div className="columns large-offset-0-5 small-12 large-11">

        <div className="meta-bar">
          <div className="row">
            <div className="column small-8">
              <ul>
                <li>
                  <span className="fa fa-location-arrow"></span>
                  {currentLocation(props.currencyCode)}
                </li>
                <li>
                  <a href={`tel:${phoneNumber(true, props.currencyCode)}`} className="grey-text">
                    <span className="fa fa-phone"></span>
                    {phoneNumber(false, props.currencyCode)}
                  </a>
                </li>
              </ul>

            </div>
            <div className="column small-4 text-right">
              <a href="https://manage.busabout.com/" rel="noopener noreferrer" target="_blank" className="orange-text"><span className="fa fa-user-o"></span> MYTRIP</a>
            </div>
          </div>
        </div>

      <div className="meta-logo-wrapper">
        <a href="https://www.busabout.com/" target="_self" className="meta-logo">
          <img src={balogo} alt="Busabout logo"/>
        </a>
      </div>

    </div>
  </div>
  )
}

export default React.memo(MetaBar);


// WEBPACK FOOTER //
// ./src/components/shared/metabar.js